import type { FrameRenderer } from '../animationRender';

export type PreviewCaptureFormat = 'jpeg' | 'png';

export type PreviewCaptureOptions = {
  format: PreviewCaptureFormat;
  quality?: number;
  signal?: AbortSignal;
};

export type PreviewCaptureResult = {
  base64: string;
  mimeType: 'image/jpeg' | 'image/png';
  width: number;
  height: number;
  warnings?: string[];
};

export type PreviewCaptureHandler = (
  options: PreviewCaptureOptions,
) => Promise<PreviewCaptureResult>;

let handler: PreviewCaptureHandler | null = null;

export function registerTemplatePreviewCapture(fn: PreviewCaptureHandler): () => void {
  handler = fn;
  return () => {
    if (handler === fn) {
      handler = null;
    }
  };
}

export function captureTemplatePreview(
  options: PreviewCaptureOptions,
): Promise<PreviewCaptureResult> {
  if (!handler) {
    return Promise.reject(new Error('Template Builder preview capture is not available.'));
  }
  return handler(options);
}

export function isTemplatePreviewCaptureRegistered(): boolean {
  return handler != null;
}

let frameRenderer: FrameRenderer | null = null;

/** Renders animation frames from the mounted off-screen preview. */
export function registerTemplateFrameRenderer(renderer: FrameRenderer): () => void {
  frameRenderer = renderer;
  return () => {
    if (frameRenderer === renderer) {
      frameRenderer = null;
    }
  };
}

export function getTemplateFrameRenderer(): FrameRenderer | null {
  return frameRenderer;
}
